export default "__VITE_ASSET__hlu1P5iO__"